import { subDays } from "date-fns";
import zonedTimeToUtc from "date-fns-tz/zonedTimeToUtc";

export const getTimeRangeForDays = (days: number) => {
  const now = new Date();

  const endDate = zonedTimeToUtc(now, "Asia/Hong_Kong").getTime();
  const startDate = zonedTimeToUtc(subDays(now, days), "Asia/Hong_Kong").getTime();

  return {
    endDate,
    startDate,
  };
};
